import React from "react";
import Content from "../../../../../../layout/content/Content";
import GalleryImage from "../../../../../../components/partials/gallery/GalleryImage";
import countryList from "react-select-country-list";
import { Card } from "react-bootstrap";
import { PreviewCard } from "../../../../../../components/Component";

const FinancialTab = ({ data }) => {

  const transactionTypes = [
    { value: "dep", label: "Deposits" },
    { value: "close", label: "Closing Funds" },
    { value: "ret", label: "Retainers" },
    { value: "settle", label: "Settlement Funds" },
    { value: "invest", label: "Investment Funds" },
    { value: "don", label: "Donations" },
    { value: "comp", label: "Compensation" },
    { value: "gift", label: "Gifts" },
    { value: "rec", label: "Recurring Payments" },
  ];

  const purpose_options = [
    { "value": "real_estate", "label": "Purchasing real estate" },
    { "value": "vehicle", "label": "Purchasing a vehicle" },
    { "value": "jewelry", "label": "Purchasing jewelry" },
    { "value": "equipment", "label": "Purchasing equipment for a business" },
    { "value": "medical_expenses", "label": "To pay for medical expenses" },
    { "value": "travel", "label": "To pay for travel" },
    { "value": "legal_fees", "label": "To pay for legal fees" },
    { "value": "legal_matter", "label": "To pay for a judgement or settlement of a legal matter" },
    { "value": "taxes", "label": "To pay for taxes" },
    { "value": "tuition", "label": "To pay tuition, board, lodging" },
    { "value": "room_board", "label": "To pay for room and board" },
    { "value": "home_rent", "label": "To pay rent for your home" },
    { "value": "business_rent", "label": "To pay rent for your business" },
    { "value": "living_expenses", "label": "Living expenses" },
    { "value": "gift", "label": "To give as a gift" },
    { "value": "leasehold_improvements", "label": "Leasehold improvements" },
    { "value": "home_renovation", "label": "Renovating your home" },
    { "value": "business_loans", "label": "To pay down business loans" },
    { "value": "business_credit_cards", "label": "To pay down business credit cards" },
    { "value": "personal_loans", "label": "To pay down personal loans" },
    { "value": "personal_credit_cards", "label": "To pay down personal credit cards" },
    { "value": "mortgages", "label": "To pay down mortgages on your home" },
    { "value": "property_renovation", "label": "Renovating a property other than your home" },
    { "value": "working_capital", "label": "Working capital for an existing business" },
    { "value": "startup_capital", "label": "Startup capital for a new business" },
    { "value": "real_estate_fund", "label": "Investing in a real estate fund" },
    { "value": "mortgage_fund", "label": "Investing in a mortgage fund" },
    { "value": "mutual_fund", "label": "Investing in a mutual fund" },
    { "value": "income_fund", "label": "Investing in an income fund" },
    { "value": "investment_fund", "label": "Investing in an investment fund" },
    { "value": "private_business", "label": "Investing in a private business" },
    { "value": "public_securities", "label": "Investing in public securities" },
    { "value": "private_placement", "label": "Investing in a private placement" },
    { "value": "other", "label": "Other" }
  ]

  const sourceOfFunds = [
    { value: "psa", label: "Personal savings account" },
    { value: "pension", label: "Pension releases" },
    { value: "stocks", label: "Sale of stocks" },
    { value: "dividends", label: "Share dividends" },
    { value: "partnership", label: "Partnership distributions" },
    { value: "property_sale", label: "Sale of personal property such as art or car" },
    { value: "gambling", label: "Gambling winnings" },
    { value: "inheritance", label: "Inheritances or gifts" },
    { value: "compensation", label: "Compensation from legal rulings or settlements" },
    { value: "employment", label: "Income from employment" },
    { value: "rental", label: "Rental Income" },
    { value: "joint_accounts", label: "Joint savings accounts" },
    { value: "investment_profits", label: "Profits from other investments" },
    { value: "business_profit", label: "Profit from legitimate business activities" },
    { value: "real_estate_sale", label: "Proceeds from the sale of real estate" },
    { value: "other", label: "Other" }
  ];

  return (
    <React.Fragment>
      {data && (
        <Content>
          <div className="nk-block-head">
            <h5 className="title">Finantial Diligence</h5>
          </div>
          <div className="card card-bordered card-stretch">
            <div className="card-inner-group">
              <div className="card-inner p-0">
                <div className="nk-tb-list nk-tb-ulist">
                  <div className="profile-ud wider">
                    <span
                      style={{
                        fontSize: "14px",
                        margin: "0px 0px 0px 20px",
                        width: "50%",
                      }}
                      className="profile-ud-label"
                    >
                      Does Matter Involve Money?
                    </span>

                    <span
                      style={{
                        textAlign: "left",
                        fontSize: "14px",
                        margin: "0px 20px 0px 0px",
                        width: "50%",
                      }}
                      id="title"
                      className="profile-ud-value"
                    >
                      {data.financial && data.financial.involve_money ? data.financial.involve_money === 'y' ? 'Yes' : "No" : 'Not Collected'}
                    </span>
                  </div>

                </div>
              </div>
            </div>
          </div>
          {data.financial && data.financial.involve_money === 'y' &&
            <>
              <div className="nk-block-head">
                <h5 className="title">Banking Information</h5>
              </div>
              <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                  <div className="card-inner p-0">
                    <div className="nk-tb-list nk-tb-ulist">
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Financial institution
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.financial_institution}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Branch address
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.branch_address}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Institution number
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.institution_number}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Transit number
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.transit_number}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Account number
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.account_number}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Exact name on account
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.account_name}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Address associated with the account
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.account_address}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Routing number
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.routing_number}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          IBAN (for international)
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.iban}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          SWIFT/BIC (for international)                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="title"
                          className="profile-ud-value"
                        >
                          {data.financial && data.financial.swift_bic}
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </>

          }


          {data.financial && data.financial.involve_money === 'y' && data.pep_hio.is_pep_hio_family === 'y' && (
            <>
              <div className="nk-block-head">
                <h5 className="title">Transaction(s) Details</h5>
              </div>
              {data.financial_transactions.map((transaction, index) => {

                return (<>
                  <PreviewCard>

                    <div className="nk-block-head">
                      <h5 className="title">Transaction {index + 1}</h5>
                    </div>
                    <div className="card card-bordered card-stretch">
                      <div className="card-inner-group">
                        <div className="card-inner p-0">
                          <div className="nk-tb-list nk-tb-ulist">
                            <div className="profile-ud wider">
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Nickname
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="title"
                                className="profile-ud-value"
                              >
                                {transaction.nickname || "Not collected"}
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Type of transaction
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="name_middle"
                                className="profile-ud-value"
                              >
                                {transactionTypes.find(item => item.value === transaction.type).label || "Not collected"}
                              </span>
                            </div>
                            <hr style={{ margin: "0" }} />
                            <div className="profile-ud wider">
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Date paid or required:
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="title"
                                className="profile-ud-value"
                              >
                                {transaction.date_paid || "Not collected"}
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Purpose of funds:
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="name_middle"
                                className="profile-ud-value"
                              >
                                {purpose_options.find(item => item.value === transaction.purpose_of_funds).label || "Not collected"}
                              </span>
                            </div>
                            <hr style={{ margin: "0" }} />
                            <div className="profile-ud wider">
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Source of funds:
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="title"
                                className="profile-ud-value"
                              >
                                {sourceOfFunds.find(item => item.value === transaction.source_of_funds).label || "Not collected"}
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Financial institution:
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="name_middle"
                                className="profile-ud-value"
                              >
                                {transaction.financial_institution || "Not collected"}
                              </span>
                            </div>
                            <hr style={{ margin: "0" }} />
                            <div className="profile-ud wider">
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Estimated amount:
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="title"
                                className="profile-ud-value"
                              >
                                {transaction.estimated_amount || "Not collected"}
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Currency:
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="name_middle"
                                className="profile-ud-value"
                              >
                                {transaction.currency || "Not collected"}
                              </span>
                            </div>

                          </div>
                        </div>
                      </div>

                    </div>
                    {transaction.type === 'ret' &&
                      <>
                        <div className="nk-block-head">
                          <h6 className="">Retainers Information</h6>
                        </div>
                        <div className="card card-bordered card-stretch">
                          <div className="card-inner-group">
                            <div className="card-inner p-0">
                              <div className="nk-tb-list nk-tb-ulist">
                                <div className="profile-ud wider">
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Rate
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="title"
                                    className="profile-ud-value"
                                  >
                                    {transaction.ret_rate || "Not collected"}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Block Fee
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="name_middle"
                                    className="profile-ud-value"
                                  >
                                    {transaction.ret_block_fee || "Not collected"}
                                  </span>
                                </div>
                                <hr style={{ margin: "0" }} />
                                <div className="profile-ud wider">
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Fixed Fee
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="title"
                                    className="profile-ud-value"
                                  >
                                    {transaction.ret_fixed_fee || "Not collected"}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Contingency:
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="name_middle"
                                    className="profile-ud-value"
                                  >
                                    {transaction.ret_contingency || "Not collected"}
                                  </span>
                                </div>
                                <hr style={{ margin: "0" }} />
                                <div className="profile-ud wider">
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Dibursements:
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="title"
                                    className="profile-ud-value"
                                  >
                                    {transaction.ret_dibursements || "Not collected"}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Notes:
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="name_middle"
                                    className="profile-ud-value"
                                  >
                                    {transaction.ret_notes || "Not collected"}
                                  </span>
                                </div>


                              </div>
                            </div>
                          </div>

                        </div>
                      </>

                    }

                    <div className="nk-block-head">
                      <h6 className="">Payor information</h6>
                    </div>
                    <div className="card card-bordered card-stretch">
                      <div className="card-inner-group">
                        <div className="card-inner p-0">
                          <div className="nk-tb-list nk-tb-ulist">
                            <div className="profile-ud wider">
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Is Payor
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="title"
                                className="profile-ud-value"
                              >
                                {transaction.is_payor === 'y' ? 'Yes' : 'No' || "Not collected"}
                              </span>
                              {transaction.is_payor === 'n' &&
                                <>
                                </>
                              }
                              <span
                                style={{
                                  fontSize: "14px",
                                  margin: "0px 0px 0px 20px",
                                  width: "25%",
                                }}
                                className="profile-ud-label"
                              >
                                Payor Name
                              </span>

                              <span
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0px 20px 0px 0px",
                                  width: "25%",
                                }}
                                id="name_middle"
                                className="profile-ud-value"
                              >
                                {transaction.payor_name || "Not collected"}
                              </span>
                            </div>
                            {transaction.is_payor === 'n' &&
                              <>
                                <hr style={{ margin: "0" }} />
                                <div className="profile-ud wider">
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Payor Address
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="title"
                                    className="profile-ud-value"
                                  >
                                    {transaction.payor_address || "Not collected"}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Payor Phone:
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="name_middle"
                                    className="profile-ud-value"
                                  >
                                    {transaction.payor_phone || "Not collected"}
                                  </span>
                                </div>
                                <hr style={{ margin: "0" }} />
                                <div className="profile-ud wider">
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Payor Email
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="title"
                                    className="profile-ud-value"
                                  >
                                    {transaction.payor_email || "Not collected"}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0px 0px 20px",
                                      width: "25%",
                                    }}
                                    className="profile-ud-label"
                                  >
                                    Payor Occupation:
                                  </span>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      fontSize: "14px",
                                      margin: "0px 20px 0px 0px",
                                      width: "25%",
                                    }}
                                    id="name_middle"
                                    className="profile-ud-value"
                                  >
                                    {transaction.payor_occupation || "Not collected"}
                                  </span>
                                </div>
                              </>
                            }



                          </div>
                        </div>
                      </div>

                    </div>



                  </PreviewCard>
                </>)
              })}

            </>

          )}
        </Content>
      )}
    </React.Fragment>
  );
};

export default FinancialTab;
